import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'
import './App.css';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import { Modal, Alert } from 'react-bootstrap';

const App = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [user, setUser] = useState('');
  const pass = useRef('');
  const [err, setErr] = useState('שם משתמש או סיסמה שגויים');
  const [authError, setAuthError] = useState(new URLSearchParams(window.location.search).get('error') === 'auth_failed');

  useEffect(() => {
    axios.get("/api/check-session")
      .then((res) => {
        if (res.data.msg === 'ok') {
          sessionStorage.setItem('usertype', res.data.type);
          sessionStorage.setItem('name', res.data.name);
          sessionStorage.setItem('semel', res.data.semel);
          sessionStorage.setItem('email', res.data.email);
          if (res.data.mosName) sessionStorage.setItem('mosName', res.data.mosName);
          if (res.data.city) sessionStorage.setItem('city', res.data.city);

          if (res.data.type === 1) {
            navigate('/principal')
          } else if (res.data.type === 2) {
            navigate('/checker')
          } else if (res.data.type === 3) {
            navigate('/departments')
          } else if (res.data.type === 4) {
            navigate('/admin')
          } else if (res.data.type === 5) {
            navigate('/dash')
          }
        }
      })
      .catch((err) => console.log(err));
  }, [navigate]);

  const handleNewPass = (event) => {
    event.preventDefault();
    event.stopPropagation();
    axios.post("api/newpass", { user: user, email: event.target.email.value })
      .then((res) => {
        console.log(res.data);
        if (res.data.msg === 'problem') {
          alert('סמל מוסד או המייל שהוזן אינו תואם את הנתונים ששמורים במערכת, נא לפנות למנהל המערכת')
        }
      }).catch((error) => {
        console.error('Error:', error);
      });
    setShow(false)
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === true) {
      axios.post("api/login", { user: user, pass: pass.current.value })
        .then((res) => {
          if (res.data.msg === 'problem') {
            pass.current.value = '';
            setErr('סיסמא או שם משתמש שגויים')
          }
          if (res.data.type === 1) {
            sessionStorage.setItem('usertype', res.data.type);
            sessionStorage.setItem('name', res.data.name);
            sessionStorage.setItem('semel', res.data.semel);
            sessionStorage.setItem('city', res.data.city);
            sessionStorage.setItem('mosName', res.data.mosName);
            sessionStorage.setItem('email', res.data.email);
            navigate('/principal')
          } else
            if (res.data.type === 2) {
              sessionStorage.setItem('usertype', res.data.type);
              sessionStorage.setItem('name', res.data.name);
              navigate('/checker')
            } else
              if (res.data.type === 3) {
                sessionStorage.setItem('usertype', res.data.type);
                sessionStorage.setItem('name', res.data.name);
                sessionStorage.setItem('semel', res.data.semel);
                sessionStorage.setItem('email', res.data.email);
                navigate('/departments')
              } else
                if (res.data.type === 4) {
                  sessionStorage.setItem('usertype', res.data.type);
                  sessionStorage.setItem('name', res.data.name);
                  sessionStorage.setItem('semel', res.data.semel);
                  sessionStorage.setItem('email', res.data.email);
                  navigate('/admin')
                } else
                  if (res.data.type === 5) {
                    sessionStorage.setItem('usertype', res.data.type);
                    sessionStorage.setItem('name', res.data.name);
                    navigate('/dash')
                  }
        }).catch((error) => {
          console.error('Error:', error);
        });
    }
    setValidated(true);
  }

  return (
    <div className="container pt-5" dir="rtl">
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row className='justify-content-md-center'>
          <Col xs={12} md={8} lg={6} xl={6} xxl={6}>
            <Card className="shadow p-3">
              <Card.Body>
                {authError && (
                  <Alert variant="danger" className="mb-3">
                    החשבון שנבחר אינו מורשה במערכת. נא לבחור חשבון Microsoft אחר.
                  </Alert>
                )}
                <Button variant="light" className="btn-microsoft" onClick={() => window.location.href = authError ? '/api/auth/microsoft/interactive' : '/api/auth/microsoft'}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 23 23" className="microsoft-logo">
                    <path fill="#f3f3f3" d="M0 0h23v23H0z" />
                    <path fill="#f35325" d="M1 1h10v10H1z" />
                    <path fill="#81bc06" d="M12 1h10v10H12z" />
                    <path fill="#05a6f0" d="M1 12h10v10H1z" />
                    <path fill="#ffba08" d="M12 12h10v10H12z" />
                  </svg>
                  כניסה באמצעות Microsoft
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default App;
